'use strict'

var isArray = require('isarray')

module.exports = function castArray (value) {
  return isArray(value) ? value : [value]
}



//////////////////
// WEBPACK FOOTER
// ../~/cast-array/index.js
// module id = 718
// module chunks = 0